import FileSaver from 'file-saver';

import { publishNotification } from '../../utils/notifications/publish-notification';
import { CoordinateManager } from '../coordinate-manager';
import { DxfFactory } from '../loader/dxf/dxf-factory';
import { Dxf } from './dxf';
import { Geometry } from './geometry';

export class AssetDownloadManager {
  /**
   * Downloads the DXF that a DWG or DXF file was converted to (exploded, by the legacy
   * conversion), for a legacy DXF asset and for the glb asset of a drawing alike, since the
   * backend writes both.
   */
  async downloadDxfAsset(
    asset: Pick<Dxf, 'fileId' | 'fileInfo' | 'selectedVersion'> & { isDownloading?: boolean },
    url?: string,
    name?: string,
    sharedViewId?: string,
  ) {
    asset.isDownloading = true;

    try {
      if (!url && !asset.fileId) {
        throw Error('Can not download asset, either file id or url needs to be provided.');
      }

      const filename: string = name ? name : asset.fileInfo!.name;
      const data: string = url
        ? await DxfFactory.instance().getDxfDataByUrl(url)
        : await DxfFactory.instance().getDxfData(
            asset.fileId,
            asset.selectedVersion?.id,
            sharedViewId,
          );

      const file = new File([data], filename.replace(/\.dwg$/i, '.dxf'), { type: 'dxf' });
      FileSaver.saveAs(file);
      asset.isDownloading = false;
    } catch (err) {
      publishNotification('err1206');
    }
  }

  async downloadGeoJson(url: string, filename: string) {
    try {
      const data = await DxfFactory.instance().getDxfDataByUrl(url);
      const geoJsonFilename = filename.replace(/(\.dwg|\.dxf)$/i, '.json');
      const file = new File([data], geoJsonFilename, { type: 'json' });

      FileSaver.saveAs(file);
    } catch (err) {
      publishNotification('err1206');
    }
  }

  downloadGeometryAsset(asset: Geometry) {
    let index = 0;
    const assetPoints = asset.wgs84Coords
      .map((c) => {
        const coords = CoordinateManager.getInstance().convertCoords(
          c.x,
          c.y,
          'wgs84',
          CoordinateManager.getInstance().getProjectProjection(),
        );
        return `${++index}\t${coords.y}\t${coords.x}\t${c.z}`;
      })
      .join('\n');

    const a = document.createElement('a');
    const fileType = 'text/plain';
    a.download = `${asset.name}.txt`;
    const blob = new Blob([assetPoints], { type: fileType });
    a.href = URL.createObjectURL(blob);
    a.dataset.downloadurl = [fileType, a.download, a.href].join(':');
    a.click();
  }
}
